export const PATIENTS_ADMIN_LIST_SET_SEARCH_QUERY = 'PATIENTS_ADMIN_LIST_SET_SEARCH_QUERY';

export const setSearchQuery = (searchQuery: string | null) => ({
  type: PATIENTS_ADMIN_LIST_SET_SEARCH_QUERY as typeof PATIENTS_ADMIN_LIST_SET_SEARCH_QUERY,
  payload: {
    searchQuery,
  } as { searchQuery: string | null },
});

export type SetSearchQuery = ReturnType<typeof setSearchQuery>;